import { render, staticRenderFns } from "./SingleLGA.vue?vue&type=template&id=9f5e4c52&"
import script from "./SingleLGA.vue?vue&type=script&lang=js&"
export * from "./SingleLGA.vue?vue&type=script&lang=js&"
import style0 from "./SingleLGA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports